module.exports = __webpack_public_path__ + "static/media/disabled-folder.427acf3f.svg";